/**
 *
 *  Usage:
 *
 *    data-sw-tooltip
 *    data-sw-original-title="<tooltip content>"
 *    data-sw-original-title="<tooltip content>"
 *
 */

var $ = require('js/sw-jquery/sw-jquery');
var selector = '[data-sw-tooltip]';

/**
 * Do the actual work of being a view builder
 *
 * @param  {jQuery} $el element to turn into a tooltip
 *
 * @deprecated Use sw-tooltip.scss instead
 */
function buildTipsy($el) {
  $el.attr('original-title', $el.data('swOriginalTitle'));
  $el.tipsy({html: true, trigger: 'hover', gravity: 's', delayOut: 1000});
}

module.exports = function($fragment) {
  $fragment.swFindWithSelf(selector).each(function() {
    var $el = $(this);

    // Conditionally load tipsy. We only need to do this once per page load
    if ($.fn.tipsy) {
      buildTipsy($el);
    } else {
      require(['js/sw-jquery/vendor/jquery.tipsy'], function(tipsyPlugin) {
        tipsyPlugin($);
        buildTipsy($el);
      });
    }

  });
};
